import { Navigate, Outlet } from 'react-router-dom';
import { useStateSelector } from '../../store/reducers';
import { useAuthSync } from '../../hooks/useAuthSync';
import LoadingScreen from '../../components/layout/LoadingScreen';

export function AuthLayout() {
  const { isReady } = useAuthSync();
  const usuario = useStateSelector((state) => state.authState.usuario);
  const isLoggedIn = Boolean(usuario?.email);

  if (!isReady) return <LoadingScreen />;
  if (isLoggedIn) return <Navigate to="/home" replace />;
  return <Outlet />;
}
